{
  "name": "nilo-ui",
  "version": "1.0.28",
  "license": "MIT",
  "scripts": {
    "ng": "nx",
    "vault": "node ./vault.js",
    "nx": "nx",
    "start": "yarn run vault && concurrently \"yarn run styles:watch\" \"nx serve\"",
    "start:contratos": "concurrently \"npm run server:contratos\" \"ng serve contratos\"",
    "server:contratos": "node apps/contratos/server/server.js",
    "test:contratos": "ng test contratos --codeCoverage",
    "test:contratos:dev": "ng test contratos --watch --detectOpenHandles --codeCoverage",
    "app:contratos": "ng serve contratos",
    "build": "ng build",
    "build:prod": "ng build --configuration default,pro --base-href /nilo-ui/",
    "styles:watch": "node libs/styles/src/lib/tools/index.js --watch",
    "styles:generate": "node libs/styles/src/lib/tools/index.js",
    "test": "ng test --codeCoverage",
    "test:ui": "ng test shared-ui --codeCoverage",
    "test:ui:generate-output": "ng test shared-ui --json --outputFile=libs/shared/ui/jest-test-results.json",
    "test:ui:dev": "ng test shared-ui --codeCoverage --watch",
    "test-debug": "ng test --detectOpenHandles",
    "lint": "nx workspace-lint && ng lint",
    "e2e": "ng e2e",
    "affected:apps": "nx affected:apps",
    "affected:libs": "nx affected:libs",
    "affected:build": "nx affected:build",
    "affected:e2e": "nx affected:e2e",
    "affected:test": "nx affected:test",
    "affected:lint": "nx affected:lint",
    "affected:dep-graph": "nx affected:dep-graph",
    "affected": "nx affected",
    "format": "nx format:write",
    "format:write": "nx format:write",
    "format:check": "nx format:check",
    "update": "nx migrate latest",
    "workspace-generator": "nx workspace-generator",
    "dep-graph": "nx dep-graph",
    "help": "nx help",
    "docs:json": "compodoc -p ./tsconfig.compodoc.json -e json -d .",
    "docs:ui": "compodoc -p ./libs/shared/ui/tsconfig.lib.json -d ./libs/shared/ui/documentation -e json",
    "contratos-build": "ng build contratos --configuration production --base-href /gft/contratos/",
    "contratos-image": "docker image build -f Dockerfile.contratos -t contratos . && docker image build -f Dockerfile.contratos.server -t contratos-server .",
    "contratos-run": "docker-compose -f docker-compose.contratos.yml up",
    "contratos-stop": "docker-compose -f docker-compose.contratos.yml down",
    "contratos-demo": "yarn contratos-build && yarn contratos-image && yarn contratos-run",
    "sonar:scan": "node ./sonar-scanner.js",
    "jib:build": "./tools/jib/bin/jib build -b jib.yaml --target=nilocontainerregistry.azurecr.io/nilo-ui:0.0.1"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.0.0",
    "@angular/cdk": "^20.0.0",
    "@angular/common": "^20.0.0",
    "@angular/compiler": "^20.0.0",
    "@angular/core": "^20.0.0",
    "@angular/forms": "^20.0.0",
    "@angular/google-maps": "^20.0.3",
    "@angular/platform-browser": "^20.0.0",
    "@angular/platform-browser-dynamic": "^20.0.0",
    "@angular/router": "^20.0.0",
    "@babel/runtime": "^7.27.6",
    "@briebug/ngrx-auto-entity": "^13.0.1",
    "@bugsnag/js": "^8.10.0",
    "@bugsnag/plugin-angular": "^8.10.0",
    "@fullcalendar/angular": "^5.6.0",
    "@fullcalendar/core": "^4.1.0",
    "@fullcalendar/daygrid": "^5.6.0",
    "@fullcalendar/interaction": "^5.6.0",
    "@fullcalendar/timegrid": "^5.6.0",
    "@ngneat/until-destroy": "^9.2.2",
    "@ngrx/component": "^19",
    "@ngrx/component-store": "^19",
    "@ngrx/effects": "^19",
    "@ngrx/entity": "^19",
    "@ngrx/operators": "^19",
    "@ngrx/router-store": "^19",
    "@ngrx/signals": "^18.0.0",
    "@ngrx/store": "^19",
    "@ngx-translate/core": "^14.0.0",
    "@ngx-translate/http-loader": "^7.0.0",
    "@nx/angular": "22.3.3",
    "@primeuix/themes": "^2.0.3",
    "@rxweb/reactive-form-validators": "^13.0.1",
    "@rxweb/types": "^1.0.6",
    "@swc/helpers": "0.5.9",
    "@types/google-maps": "^3.2.4",
    "@types/inputmask": "^5.0.3",
    "@types/lodash": "^4.14.195",
    "angular-oauth2-oidc": "^20.0.2",
    "bootstrap": "^5.3.7",
    "fast-deep-equal": "^3.1.3",
    "file-saver": "^2.0.5",
    "form-data": "^4.0.4",
    "fuse.js": "^7.1.0",
    "http-proxy-middleware": "^3.0.5",
    "inputmask": "^5.0.7",
    "jest-junit": "^16.0.0",
    "lodash": "^4.17.21",
    "ng-dynamic-component": "^10.7.0",
    "ngrx-forms": "^8.0.0",
    "primeicons": "7",
    "primeng": "20",
    "rxjs": "7.8.2",
    "string-sanitizer": "^2.0.2",
    "strip-ansi": "^7.1.0",
    "tslib": "^2.3.0",
    "uuid": "^8.3.2",
    "xlsx": "https://cdn.sheetjs.com/xlsx-0.20.3/xlsx-0.20.3.tgz",
    "xml-formatter": "^3.3.2",
    "zone.js": "0.14.7"
  },
  "devDependencies": {
    "@angular-devkit/architect": "^0.2000.0",
    "@angular-devkit/core": "^20.0.0",
    "@angular-devkit/schematics": "^20.0.0",
    "@angular-eslint/eslint-plugin": "^18",
    "@angular-eslint/eslint-plugin-template": "^18",
    "@angular-eslint/template-parser": "^18",
    "@angular/build": "^20.0.0",
    "@angular/cli": "^20.0.0",
    "@angular/compiler-cli": "^20.0.0",
    "@angular/language-service": "^20.0.0",
    "@cypress/code-coverage": "^3.9.2",
    "@istanbuljs/nyc-config-typescript": "^1.0.1",
    "@ngrx/schematics": "^19",
    "@ngrx/store-devtools": "^18",
    "@nx/cypress": "22.3.3",
    "@nx/devkit": "22.3.3",
    "@nx/eslint": "22.3.3",
    "@nx/eslint-plugin": "22.3.3",
    "@nx/jest": "22.3.3",
    "@nx/js": "22.3.3",
    "@nx/node": "22.3.3",
    "@nx/plugin": "22.3.3",
    "@nx/workspace": "22.3.3",
    "@swc-node/register": "1.8.0",
    "@swc/cli": "0.6.0",
    "@swc/core": "1.3.99",
    "@swc/jest": "^0.2.39",
    "@types/jest": "29.4.4",
    "@types/node": "^18.16.9",
    "@types/uuid": "^8.3.0",
    "@typescript-eslint/eslint-plugin": "8.52.0",
    "@typescript-eslint/parser": "8.52.0",
    "chokidar": "^3.5.1",
    "clean-css": "^5.3.3",
    "concurrently": "^7.2.1",
    "cypress": "7.7.0",
    "dotenv": "10.0.0",
    "eslint": "9.31.0",
    "eslint-config-prettier": "9.1.0",
    "eslint-plugin-cypress": "2.15.2",
    "eslint-plugin-prettier": "^3.4.0",
    "eslint-plugin-sonarjs": "^0.5.0",
    "faker": "^5.1.0",
    "istanbul-lib-coverage": "3.2.2",
    "jasmine-marbles": "^0.9.2",
    "jest": "29.4.3",
    "jest-create-mock-instance": "2.0.0",
    "jest-environment-jsdom": "29.4.3",
    "jest-extended": "^4.0.2",
    "jest-jasmine2": "29.4.3",
    "jest-marbles": "3.0.2",
    "jest-preset-angular": "14.6.2",
    "jest-sonar-reporter": "^2.0.0",
    "json-server": "0.17.4",
    "jsonc-eslint-parser": "^2.1.0",
    "ng-mocks": "13.5.2",
    "ng-packagr": "19.2.2",
    "ngx-translate-testing": "^6.1.0",
    "node-vault": "^0.10.5",
    "nx": "22.3.3",
    "nyc": "^15.1.0",
    "prettier": "2.6.2",
    "sass": "^1.49.4",
    "sonarqube-scanner": "^3.3.0",
    "source-map-support": "^0.5.19",
    "ts-jest": "29.4.6",
    "ts-morph": "^18.0.0",
    "ts-node": "10.9.1",
    "typescript": "^5.8.2"
  },
  "resolutions": {
    "form-data": "2.5.4",
    "@cypress/request": "3.0.0",
    "koa": "3.1.2",
    "tmp": "0.2.4",
    "qs": "6.14.2"
  },
  "jestSonar": {
    "sonar56x": true,
    "reportPath": "coverage",
    "reportFile": "sonar-report.xml",
    "indent": 4
  },
  "jest": {
    "collectCoverage": true,
    "testResultsProcessor": "jest-sonar-reporter",
    "roots": [
      "libs",
      "coverage"
    ],
    "maxWorkers": "50%",
    "cache": true,
    "testPathIgnorePatterns": [
      "/node_modules/",
      "/dist/"
    ],
    "modulePathIgnorePatterns": [
      "/dist/"
    ]
  },
  "nyc": {
    "extends": "@istanbuljs/nyc-config-typescript",
    "all": true
  }
}
